import React, { useState } from "react";

function Products() {
  const [searchActive, setSearchActive] = useState(false);
  const activateSearch = () => {
    setSearchActive(true);
  };
  console.log(searchActive);

  return (
    <div className="bg-white mb-[30vh] flex flex-col gap-2 md:gap-6 items-center justify-center pt-3 md:pt-5 pb-20 min-h-max relative z-50">
      <div
        onClick={() => setSearchActive(false)}
        className="bg-transparent absolute h-full top-0 left-0 w-full z-30"
      ></div>
      <div className="text-black w-full p-1 px-8 md:px-10 flex justify-end">
        <div
          onClick={activateSearch}
          className={`flex ${
            searchActive
              ? "w-full md:w-3/12 px-4"
              : "w-max cursor-pointer hover:border-black"
          }  justify-between items-center rounded-full overflow-hidden relative z-40 border border-black/50 p-2 gap-3 duration-300`}
        >
          <input
            type="text"
            placeholder="Search"
            className={`${
              !searchActive && "hidden"
            } flex-grow text-black placeholder:text-black placeholder:text-sm text-base bg-transparent outline-none outline-0`}
          />
          <i className="fa-solid fa-magnifying-glass p-1 cursor-pointer text-black"></i>
        </div>
      </div>
      <div className="flex flex-wrap w-full gap-0 relative z-40">
        <div className="bg-white p-2 border border-black/30 flex-grow flex items-center flex-col justify-between w-[150px] md:w-[250px] h-[350px]">
          <div className="flex-1 grid place-items-center w-full overflow-hidden">
            <img src={require("../images/serum.png")} alt="" className="" />
          </div>
          <div className="w-10/12 flex flex-col gap-1 text-center">
            <p className="text-base font-semibold cursor-pointer hover:underline">
              Skin Serum 100
            </p>
            <p className="text-lg font-semibold">$23.50</p>
            <div className="text-xs bg-black hover:bg-white border border-black hover:text-black text-white p-4 uppercase font-semibold text-center cursor-pointer">
              Add to cart
            </div>
          </div>
        </div>
        <div className="bg-white p-2 border border-black/30 flex-grow flex items-center flex-col justify-between w-[150px] md:w-[250px] h-[350px]">
          <div className="flex-1 grid place-items-center w-full overflow-hidden">
            <img src={require("../images/serum.png")} alt="" className="" />
          </div>
          <div className="w-10/12 flex flex-col gap-1 text-center">
            <p className="w-full truncate text-base font-semibold cursor-pointer hover:underline">
              Skin Serum 100 Skin Serum 100
            </p>
            <p className="text-lg font-semibold">$23.50</p>
            <div className="text-xs bg-black hover:bg-white border border-black hover:text-black text-white p-4 uppercase font-semibold text-center cursor-pointer">
              Add to cart
            </div>
          </div>
        </div>
        <div className="bg-white p-2 border border-black/30 flex-grow flex items-center flex-col justify-between w-[150px] md:w-[250px] h-[350px]">
          <div className="flex-1 grid place-items-center w-full overflow-hidden">
            <img src={require("../images/serum.png")} alt="" className="" />
          </div>
          <div className="w-10/12 flex flex-col gap-1 text-center">
            <p className="text-base font-semibold cursor-pointer hover:underline">
              Skin Serum 100
            </p>
            <p className="text-lg font-semibold">$23.50</p>
            <div className="text-xs bg-black hover:bg-white border border-black hover:text-black text-white p-4 uppercase font-semibold text-center cursor-pointer">
              Add to cart
            </div>
          </div>
        </div>
        <div className="bg-white p-2 border border-black/30 flex-grow flex items-center flex-col justify-between w-[150px] md:w-[250px] h-[350px]">
          <div className="flex-1 grid place-items-center w-full overflow-hidden">
            <img src={require("../images/serum.png")} alt="" className="" />
          </div>
          <div className="w-10/12 flex flex-col gap-1 text-center">
            <p className="text-base font-semibold cursor-pointer hover:underline">
              Skin Serum 100
            </p>
            <p className="text-lg font-semibold">$23.50</p>
            <div className="text-xs bg-black hover:bg-white border border-black hover:text-black text-white p-4 uppercase font-semibold text-center cursor-pointer">
              Add to cart
            </div>
          </div>
        </div>
        <div className="bg-white p-2 border border-black/30 flex-grow flex items-center flex-col justify-between w-[150px] md:w-[250px] h-[350px]">
          <div className="flex-1 grid place-items-center w-full overflow-hidden">
            <img src={require("../images/serum.png")} alt="" className="" />
          </div>
          <div className="w-10/12 flex flex-col gap-1 text-center">
            <p className="text-base font-semibold cursor-pointer hover:underline">
              Skin Serum 100
            </p>
            <p className="text-lg font-semibold">$23.50</p>
            <div className="text-xs bg-black hover:bg-white border border-black hover:text-black text-white p-4 uppercase font-semibold text-center cursor-pointer">
              Add to cart
            </div>
          </div>
        </div>
        <div className="bg-white p-2 border border-black/30 flex-grow flex items-center flex-col justify-between w-[150px] md:w-[250px] h-[350px]">
          <div className="flex-1 grid place-items-center w-full overflow-hidden">
            <img src={require("../images/serum.png")} alt="" className="" />
          </div>
          <div className="w-10/12 flex flex-col gap-1 text-center">
            <p className="text-base font-semibold cursor-pointer hover:underline">
              Skin Serum 100
            </p>
            <p className="text-lg font-semibold">$23.50</p>
            <div className="text-xs bg-black hover:bg-white border border-black hover:text-black text-white p-4 uppercase font-semibold text-center cursor-pointer">
              Add to cart
            </div>
          </div>
        </div>
        <div className="bg-white p-2 border border-black/30 flex-grow flex items-center flex-col justify-between w-[150px] md:w-[250px] h-[350px]">
          <div className="flex-1 grid place-items-center w-full overflow-hidden">
            <img src={require("../images/serum.png")} alt="" className="" />
          </div>
          <div className="w-10/12 flex flex-col gap-1 text-center">
            <p className="text-base font-semibold cursor-pointer hover:underline">
              Skin Serum 100
            </p>
            <p className="text-lg font-semibold">$23.50</p>
            <div className="text-xs bg-black hover:bg-white border border-black hover:text-black text-white p-4 uppercase font-semibold text-center cursor-pointer">
              Add to cart
            </div>
          </div>
        </div>
        <div className="bg-white p-2 border border-black/30 flex-grow flex items-center flex-col justify-between w-[150px] md:w-[250px] h-[350px]">
          <div className="flex-1 grid place-items-center w-full overflow-hidden">
            <img src={require("../images/serum.png")} alt="" className="" />
          </div>
          <div className="w-10/12 flex flex-col gap-1 text-center">
            <p className="text-base font-semibold cursor-pointer hover:underline">
              Skin Serum 100
            </p>
            <p className="text-lg font-semibold">$23.50</p>
            <div className="text-xs bg-black hover:bg-white border border-black hover:text-black text-white p-4 uppercase font-semibold text-center cursor-pointer">
              Add to cart
            </div>
          </div>
        </div>
        <div className="bg-white p-2 border border-black/30 flex-grow flex items-center flex-col justify-between w-[150px] md:w-[250px] h-[350px]">
          <div className="flex-1 grid place-items-center w-full overflow-hidden">
            <img src={require("../images/serum.png")} alt="" className="" />
          </div>
          <div className="w-10/12 flex flex-col gap-1 text-center">
            <p className="text-base font-semibold cursor-pointer hover:underline">
              Skin Serum 100
            </p>
            <p className="text-lg font-semibold">$23.50</p>
            <div className="text-xs bg-black hover:bg-white border border-black hover:text-black text-white p-4 uppercase font-semibold text-center cursor-pointer">
              Add to cart
            </div>
          </div>
        </div>
        <div className="bg-white p-2 border border-black/30 flex-grow flex items-center flex-col justify-between w-[150px] md:w-[250px] h-[350px]">
          <div className="flex-1 grid place-items-center w-full overflow-hidden">
            <img src={require("../images/serum.png")} alt="" className="" />
          </div>
          <div className="w-10/12 flex flex-col gap-1 text-center">
            <p className="text-base font-semibold cursor-pointer hover:underline">
              Skin Serum 100
            </p>
            <p className="text-lg font-semibold">$23.50</p>
            <div className="text-xs bg-black hover:bg-white border border-black hover:text-black text-white p-4 uppercase font-semibold text-center cursor-pointer">
              Add to cart
            </div>
          </div>
        </div>
        <div className="bg-white p-2 border border-black/30 flex-grow flex items-center flex-col justify-between w-[150px] md:w-[250px] h-[350px]">
          <div className="flex-1 grid place-items-center w-full overflow-hidden">
            <img src={require("../images/serum.png")} alt="" className="" />
          </div>
          <div className="w-10/12 flex flex-col gap-1 text-center">
            <p className="text-base font-semibold cursor-pointer hover:underline">
              Skin Serum 100
            </p>
            <p className="text-lg font-semibold">$23.50</p>
            <div className="text-xs bg-black hover:bg-white border border-black hover:text-black text-white p-4 uppercase font-semibold text-center cursor-pointer">
              Add to cart
            </div>
          </div>
        </div>
        <div className="bg-white p-2 border border-black/30 flex-grow flex items-center flex-col justify-between w-[150px] md:w-[250px] h-[350px]">
          <div className="flex-1 grid place-items-center w-full overflow-hidden">
            <img src={require("../images/serum.png")} alt="" className="" />
          </div>
          <div className="w-10/12 flex flex-col gap-1 text-center">
            <p className="text-base font-semibold cursor-pointer hover:underline">
              Skin Serum 100
            </p>
            <p className="text-lg font-semibold">$23.50</p>
            <div className="text-xs bg-black hover:bg-white border border-black hover:text-black text-white p-4 uppercase font-semibold text-center cursor-pointer">
              Add to cart
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Products;
// h-[400px] w-[280px]
// h-[400px] w-[280px]
// h-[400px] w-[280px]
// h-[400px] w-[280px]
// h-[400px] w-[280px]
// h-[400px] w-[280px]
// h-[400px] w-[280px]
// h-[400px] w-[280px]
// h-[400px] w-[280px]
// h-[400px] w-[280px]
// h-[400px] w-[280px]
// h-[400px] w-[280px]
